exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".cke_menu_panel iframe:not(.md-image){height:inherit}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/client/Content.vue"],"names":[],"mappings":"AACA,sCACE,cAAgB,CACjB","file":"Content.vue","sourcesContent":["\n.cke_menu_panel iframe:not(.md-image) {\n  height: inherit;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec3a5cd8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/client/Content.vue
// module id = 2011
// module chunks = 0